import { render, staticRenderFns } from "./listUser.vue?vue&type=template&id=0b1ef305&scoped=true"
import script from "./listUser.vue?vue&type=script&lang=js"
export * from "./listUser.vue?vue&type=script&lang=js"
import style0 from "./listUser.vue?vue&type=style&index=0&id=0b1ef305&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1ef305",
  null
  
)

export default component.exports